RivalIQ.apps.SocialChannelMatrix.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Matrix = widgets.Matrix = RivalIQ.views.LayoutView.mixin({
        className: 'panel x-widget-social-channel-matrix-matrix',
        template: '#widgetSocialChannelMatrixMatrixTemplate',
        regions: {
            progress: '.x-progress-region',
            status: '.x-status-region',
            matrix: '.x-matrix-region'
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        behaviors: {
            Dismissible: {}
        },

        dashboardModelEvents: {
            'change:companySetDescriptor': 'showSocialChannelMatrix'
        },

        loadData: function () {
            const me = this;
            return RivalIQ.data.companyData.fetchPresences(me.getProps())
                .then(function (presencePeriodSummary) {
                    me.presencePeriodSummary = presencePeriodSummary;
                    me.listenTo(App, 'company:found', me.onCompanyUpdated);
                    me.listenTo(App, 'userEdit', me.onUserEdit);
                });
        },

        onCompanyUpdated: function (company) {

            const me = this;
            const model = me.presencePeriodSummary.get(company.id);
            model.set(company);
            me.showProgress();
            me.showStatus();
        },

        onRenderLoaded: function () {

            const me = this;
            me.showProgress();
            me.showStatus();
            me.showSocialChannelMatrix();
        },

        onUserEdit: function () {
            const me = this;
            me.reload();
        },

        showSocialChannelMatrix: function () {

            const me = this;
            const companySetDescriptor = me.getProp('companySetDescriptor');
            const companies = me.presencePeriodSummary.getCompaniesByCompanySet(companySetDescriptor);

            const view = new App.views.MatrixList({
                collection: new Backbone.Collection(companies),
                dashboardModel: me.dashboardModel,
                showRemoveAction: false
            });

            me.matrix.show(view);
        },

        getLandscapeCompletion: function () {
            const me = this;
            const total = me.presencePeriodSummary.length;

            const completed = me.presencePeriodSummary.reject(function (company) {

                return company.stillFinding();
            }).length;

            let percentage = 0;

            if (completed > 0) {

                percentage = completed / total;
            }

            return {
                completed: (percentage === 1),
                completion: RivalIQ.formatter.formatPercentage(percentage)
            };
        },

        showProgress: function () {

            const me = this;
            const completion = me.getLandscapeCompletion();

            const view = new Marionette.ItemView({
                className: function () {

                    let className = 'x-progress';

                    if (completion.completed) {

                        className += ' x-completed';
                    }

                    if (me.presencePeriodSummary.isUnderReview({
                        recent: true
                    })) {

                        className += ' x-under-review';
                    }

                    return className;
                },
                model: new Backbone.Model(completion),
                template: '#widgetSocialChannelMatrixProgressTemplate'
            });

            me.progress.show(view);
        },

        showStatus: function () {

            const me = this;
            let template = null;

            const findingOrWaiting = me.presencePeriodSummary.filter(function (company) {

                return company.stillFinding();
            }).length;

            if (findingOrWaiting > 0) {
                template = '#widgetSocialChannelMatrixFindingTemplate';
            } else {
                template = '#widgetSocialChannelMatrixReviewingTemplate';
            }

            const view = new Marionette.ItemView({
                template: template
            });

            me.status.show(view);
        }
    });


    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const MatrixOverviewWidget = Widget.extend({
        view: Matrix,
        panelView: Matrix,
        filter: function () {
            const me = this;

            const widgets = RivalIQ.state.landscape.get('widgets');
            const persisted = (widgets[me.instanceId] || {});

            return me.isExporting() ||
                (persisted.dismissed === true) ||
                !persisted.available;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_CHANNEL_MATRIX_OVERVIEW, MatrixOverviewWidget);

    const MatrixWidget = widgets.MatrixList = Widget.extend({
        title: RivalIQ.strings.companies_title,
        description: RivalIQ.strings.companies_info,
        view: App.views.MatrixList,
        viewMore: false,
        allowPageBreaks: true,

        exportFormats: [
            RivalIQ.enums.exportFormat.CSV,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PPT
        ],

        csvExportProps: function () {
            const me = this;

            return {
                type: 'socialChannelMatrix',
                timePeriod: me.getProp('timePeriod'),
                companySetDescriptor: me.getProp('companySetDescriptor')
            };
        },

        getFilename: function () {
            return RivalIQ.export.filename.base({
                title: 'companies'
            });
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_CHANNEL_MATRIX, MatrixWidget);
});
